import { FC } from "react";
import styles from "./GirlItem.module.scss";
import { TBustSize } from "../../types/user";
import phoneSvg from "../../images/icons/call.svg";
import whatsappSvg from "../../images/icons/whatsapp.svg";
import emailSvg from "../../images/icons/email.svg";
import { useNavigate } from "react-router-dom";
import { TServiceId } from "../../types/service";

export interface IGirlItem {
  id: number;
  age: number | undefined;
  bust: TBustSize | undefined;
  weight: string | undefined;
  height: string | undefined;
  name: string;
  city: string | null;
  zipIndex: string | null;
  services: { id: TServiceId; serviceName: string }[]; // HJ, HE, HV
  photoSrc: string;
  phone: string | undefined;
  whatsapp: string | undefined;
  email: string | undefined;
}

export const GirlItem: FC<IGirlItem> = ({
  id,
  age,
  bust,
  weight,
  height,
  name,
  city,
  zipIndex,
  services,
  photoSrc,
  phone,
  whatsapp,
  email,
}) => {
  const navigate = useNavigate();
  return (
    <div className={styles.card} onClick={() => navigate(`/models/${id}`)}>
      <div className={styles.wrapper}>
        <img
          src={photoSrc ?? "https://placehold.co/400"}
          onError={(e) => {
            e.currentTarget.src = "https://placehold.co/400";
          }}
          alt={name}
          className={styles.photo}
        />
        <div className={styles.info}>
          <ul className={styles.character}>
            <li>
              <span className={styles.character__name}>Alter:</span>{" "}
              <span>{age ?? "-"}</span>
            </li>
            <li>
              <span className={styles.character__name}>Brust:</span>{" "}
              <span>{bust ?? "-"}</span>
            </li>
            <li>
              <span className={styles.character__name}>Gewicht:</span>{" "}
              <span>{weight ?? "-"}</span>
            </li>
            <li>
              <span className={styles.character__name}>Wachstum:</span>{" "}
              <span>{height ?? "-"}</span>
            </li>
          </ul>
          <ul className={styles.skills}>
            {services.map((skill) => (
              <li className={styles.skill} key={skill.id}>
                {skill.serviceName}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <h4 className={styles.location}>
        <span className={styles.name}>{name}</span>
        {city && ", " + city}
        {zipIndex && ", " + zipIndex}
      </h4>
      <address className={styles.buttons}>
        <a
          href={`tel:${phone}`}
          target="_blank"
          onClick={(e) => e.stopPropagation()}
          className={`${styles.button} ${!phone && styles.disabled}`}
        >
          <img
            src={phoneSvg}
            className={styles.button__icon}
            alt="Telefonnummer"
          />
          <span className={styles.button__text}>Telefonnummer</span>
        </a>
        <a
          target="_blank"
          onClick={(e) => e.stopPropagation()}
          href={whatsapp}
          className={`${styles.button} ${!whatsapp && styles.disabled}`}
        >
          <img
            src={whatsappSvg}
            className={styles.button__icon}
            alt="whatsapp"
          />
        </a>
        <a
          onClick={(e) => e.stopPropagation()}
          target="_blank"
          href={`mailto:${email}`}
          className={`${styles.button} ${!email && styles.disabled}`}
        >
          <img src={emailSvg} className={styles.button__icon} alt="email" />
        </a>
      </address>
    </div>
  );
};
